// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const DbsAutoSubmit = t.struct({
    allowedOptions: t.Array,
    key: t.String,
    value: t.String
}, {
    name: 'DbsAutoSubmit',
    strict: true
});

export const getDefaultState = () => new DbsAutoSubmit({
    allowedOptions: [],
    key: '',
    value: ''
});

export default DbsAutoSubmit;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dbs-autosubmit.js